import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetEventFingerprintsQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetEventFingerprintsQuery = {
  __typename?: 'Query';
  eventFingerprints: {
    __typename?: 'EventFingerprintConnection';
    edges: Array<{
      __typename?: 'EventFingerprintEdge';
      cursor: string;
      node: {
        __typename?: 'EventFingerprint';
        id: any;
        eventHash: string;
        signatureText: string;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export const GetEventFingerprintsDocument = gql`
  query GetEventFingerprints(
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    eventFingerprints(
      after: $after
      before: $before
      first: $first
      last: $last
    ) {
      edges {
        node {
          id
          eventHash
          signatureText
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

/**
 * __useGetEventFingerprintsQuery__
 *
 * To run a query within a React component, call `useGetEventFingerprintsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventFingerprintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventFingerprintsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetEventFingerprintsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEventFingerprintsQuery,
    GetEventFingerprintsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEventFingerprintsQuery,
    GetEventFingerprintsQueryVariables
  >(GetEventFingerprintsDocument, options);
}
export function useGetEventFingerprintsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventFingerprintsQuery,
    GetEventFingerprintsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEventFingerprintsQuery,
    GetEventFingerprintsQueryVariables
  >(GetEventFingerprintsDocument, options);
}
export function useGetEventFingerprintsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetEventFingerprintsQuery,
        GetEventFingerprintsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEventFingerprintsQuery,
    GetEventFingerprintsQueryVariables
  >(GetEventFingerprintsDocument, options);
}
export type GetEventFingerprintsQueryHookResult = ReturnType<
  typeof useGetEventFingerprintsQuery
>;
export type GetEventFingerprintsLazyQueryHookResult = ReturnType<
  typeof useGetEventFingerprintsLazyQuery
>;
export type GetEventFingerprintsSuspenseQueryHookResult = ReturnType<
  typeof useGetEventFingerprintsSuspenseQuery
>;
export type GetEventFingerprintsQueryResult = Apollo.QueryResult<
  GetEventFingerprintsQuery,
  GetEventFingerprintsQueryVariables
>;
